<template>
    <card>
       <template slot="header">
          <h3 class="card-title">Schedule Adjustment</h3>
       </template>
             <nav class="row">
                <ol class="breadcrumb arr-right bg-breadcrum">
                   <li class="breadcrumb-item">
                      <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                   </li>
                   <li class="breadcrumb-item">
                      <router-link to="/hr/employeelist">Active Employees</router-link>
                   </li>
                   <li class="breadcrumb-item">
                      <router-link to="/hr/resigned">Inactive Employees</router-link>
                   </li>
                   <li class="breadcrumb-item">
                      <router-link to="/hr/dependents">Dependents</router-link>
                   </li>
                   <li class="breadcrumb-item">
                      <router-link to="/hr/workshifts">Workshifts</router-link>
                   </li>
                   <!-- NEW ADDITIONAL -->
                   <li class="breadcrumb-item active">Schedule Adjustment</li>
                   <li class="breadcrumb-item">
                      <router-link to="/hr/undertimerequest">Undertime Request</router-link>
                   </li>
                   <li class="breadcrumb-item">
                      <router-link to="/hr/nterequest">NTE Tracker</router-link>
                   </li>
                   <li class="breadcrumb-item">
                      <router-link to="/hr/coaching/records">Employee Coached</router-link>
                    </li>
                </ol>
             </nav>
          <hr style="margin-top:-10px"/>
          <div class="row">  
            <div class="col-md-6"></div>
            <div class="col-md-6">
             <router-link to="/hr/adjustmentform" class="btn btn-primary float-right"><i class="fa fa-plus"></i>&nbsp;Encode Adjustment Maually</router-link>
            </div>
          </div>
         <hr/>
       <div class="row">
          <div class="col-md-10">
             <p><i class="fa fa-search"></i> Search Employee</p>
             <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
          </div>
          <div class="col-md-1">
             <div class="form-group">
                <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                <select v-model="order_by" class="form-control" required>
                   <option value="">Default</option>
                   <option value="-1">ASC</option>
                   <option value="1">DESC</option>
                </select>
             </div>
          </div>
          <div class="col-md-1">
             <div class="form-group">
                <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                <select v-model="page_limit" class="form-control" required>
                   <option value="">Default</option>
                   <option value="5">5</option>
                   <option value="10">10</option>
                   <option value="25">25</option>
                   <option value="50">50</option>
                   <option value="100">100</option>
                   <option value="500">500</option>
                </select>
             </div>
          </div>
       </div>
       <hr>
       <!-- PAGINATION -->
       <b-pagination
          v-model="curentPage"
          :total-rows="items.length"
          :per-page="perPage"
          aria-controls="my-table"
          align="right"
          first-text="First"
          prev-text="Prev"
          next-text="Next"
          last-text="Last"
          ></b-pagination>
       <!-- END PAGINATION -->
       <hr>
       <div class="table-responsive ">
          <table class="table table-striped table-hover " v-loading="loading">
             <thead>
                <tr>
                   <th>#</th>
                   <th>Employee Name</th>
                   <th>Current Shift</th>
                   <th>Requested Shift</th>
                   <th><i class="fa fa-calendar"></i>Date Requested</th>
                   <th>Reason</th>
                   <th>Status</th>
                   <!-- <th>Created At</th> -->
                </tr>
             </thead>
             <tbody>
                <tr v-for="item,index in computedEmployee">
                   <template v-if="item === 'no data found'">
                      <td colspan="100%">
                         <h4>  <i class="fa fa-database"></i> Empty Records ...</h4>
                      </td>
                   </template>
                   <template v-else>
                      <td>{{index + 1}}.</td>
                      <td> <b>{{item.full_name | capitalize }}</b> <br/><i>{{item.position_name}}</i></td>
                      <td><i class="fa fa-clock-o"></i>&nbsp;{{item.current_shift}}</td>
                      <td><i class="fa fa-clock-o"></i>&nbsp;{{item.requested_shift}}</td>
                      <td>{{getDate(item.date_of_request)}}</td>
                      <td>
                         <template v-if="item.reason_for_change.length < 50">{{ item.reason_for_change }}</template>
                         <template v-if="item.reason_for_change.length >= 50">{{ item.reason_for_change .substring(0,50)+"..." }}</template>
                      </td>
                      <td>
                         <span v-if="item.hr_status === 'pending'">
                         <button class="pending">Pending</button>
                         </span>    
                         <span v-else-if="item.hr_status === 'approved'"> 
                         <button class="approved ">Approved</button>
                         </span> 
                         <span v-else-if="item.hr_status === 'rejected'"> 
                         <button class="rejected">Rejected</button>
                         </span>   
                      </td>
                      <td width="165">
                         <router-link :to="{name: 'schedule-edit-adjustment-form', params: { id: item.id }}" v-b-tooltip.hover title="click to view details and modify records" class="btn btn-xs"><i class="fa fa-eye"></i>View</router-link>
                         <button  class="btn btn-xs" @click = "deleteItem(item.id, index)" v-b-tooltip.hover title="Delete Entry">
                            <li class="fa fa-trash-o"></li>
                            &nbsp;Delete
                         </button>
                      </td>
                   </template>
                </tr>
             </tbody>
          </table><br/>
          <!-- PAGINATION NATIVE WAY -->
          <div class="row">
             <div class="col-md-6">
                <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
             </div>
             <div class="col-md-6">
                <b-pagination
                   v-model="curentPage"
                   :total-rows="items.length"
                   :per-page="perPage"
                   aria-controls="my-table"
                   align="right"
                   first-text="First"
                   prev-text="Prev"
                   next-text="Next"
                   last-text="Last"
                   ></b-pagination>
             </div>
          </div>
          <!-- END PAGINATION -->     
          <template v-if="display_indicator === 1">
            <center>
               <br/><br/>
               <img  src="/static/img/warning.png"  width="225" height="190">
               <h1>You've lost your network connection</h1>
               <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
               <br/><br/>
            </center>
         </template>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
       </div>
    </card>
 </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
  components: {
    Card,
  },

  data() {
    return {
      items: [],
      employees: [],
      loading: true,
      //FILTER
      search: '',
      order_by: '',
      page_limit: '',
      start_page: 1,
      sortAsc: true,
      //PAGINATION
      perPage: 100,
      curentPage: 1,
      //Indicator
      display_indicator: '',
    }
  },

  mounted: function () {
    this.get_schedule_adjustment_record();
  },

  methods: {
    get_schedule_adjustment_record() {
      axios.get('api/scheduleadjustment')
        .then(response => {
          this.items = response.data
          this.loading = false
          this.display_indicator = 2;
        })
        .catch(e => {
          console.log(e.response)
          this.display_indicator = 1;
        });
    },
    deleteItem(id, index) {

      /* USING SWEET ALERT */

      this.$swal({
          title: 'Are you sure?',
          text: 'You can\'t revert your action',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes Delete it!',
          cancelButtonText: 'No, Keep it!',
          showCloseButton: false,
          showLoaderOnConfirm: true
        })
        .then((isConfirm) => {
          if (isConfirm === true) {
            axios.delete('api/scheduleadjustment/delete/' + id)
              .then(response => {
                this.get_schedule_adjustment_record(); //--> reloader 
                this.$swal('Deleted', 'You successfully deleted this file', 'success')
              })
              .catch(response => {
                //alert("error");
                console.log(response);
                this.$swal('Error Code', 'Review your code', 'error')
              });
          }
        });


    }

  },
  computed: {

    offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit() {
      return this.offset + this.page_limit;
    },
    total_item() {
      return this.items.length
    },

    computedEmployee() {
      let filtered = this.items
      // USE IN PAGINATION 
      let start = (this.curentPage - 1) * this.perPage
      let end = this.curentPage * this.perPage
      filtered = filtered.slice(start, end);

      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME  
        if (this.search) {
          filtered = filtered.filter(
            item => item.full_name.toLowerCase().indexOf(this.search) > -1
          );
          return filtered
        }

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered
        }

        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort((a, b) => a.full_name < b.full_name ? this.order_by : -this.order_by)
          return filtered
        }
      }
      return filtered
    }
  },

}
</script>





// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-schedule-adjustment.vue